import { Div, Span, Rate, Text } from "@tblabs/truffle";
import { Product } from "../../Models/Product/Product";


export class ProductStatusBox extends Div
{
    constructor(product: Product)
    {
        super("product__status");

        const rating = product.Rating.Plus(1); // ex. 4.93 = 5 stars, not 4

        this.Append(
            new Div("product__status-availability").Append(
                new Span("product__status-text").Text(product.StatusLabel.value).Color(product.StatusColor.value)
            ),
            new Div("product__status-rating-container").Append(
                new Div("product__status-rating").Append(
                    new Rate(rating, {
                        SelectedSymbol: "⭐", DeselectedSymbol: "⭐", Count: 5, Readonly: true,
                        DeselectedStyle: "opacity: 0.3"
                    }).Class("product__status-rating")
                ),
                new Div("product__status-score").Append(
                    new Text(product.Rating).Class("product__status-score-value"),
                    new Span("product__status-score-max").Text("/ 5")
                )
            )
        );
    }
}
